/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pnk_Item_Err_New_Lot_Adjustment_OnlyInputs */

const vi_pl_pnk_item_err_new_lot_adjustment_only = /** @type {(inputs: Pl_Pnk_Item_Err_New_Lot_Adjustment_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ phiếu nhập lý do "Điều chỉnh" mới được tạo lô mới`)
};

/**

* @param {Pl_Pnk_Item_Err_New_Lot_Adjustment_OnlyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pnk_item_err_new_lot_adjustment_only = /** @type {((inputs?: Pl_Pnk_Item_Err_New_Lot_Adjustment_OnlyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pnk_Item_Err_New_Lot_Adjustment_OnlyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pnk_item_err_new_lot_adjustment_only(inputs)
});